import React, { useState, useEffect } from "react";
import "./input-text.css";

type InputTextProps = {
  name: string;
  label?: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  classes?: string;
  value: string;
  onChange: (value: string) => void;
  validateField?: (value: string) => string | undefined;
  translate?: (text: string) => string;
};

const InputText: React.FC<InputTextProps> = ({
  name,
  label,
  type = "text",
  placeholder = "",
  required = false,
  disabled = false,
  readonly = false,
  classes = "",
  value,
  onChange,
  validateField = () => undefined,
  translate = (t) => t,
}) => {
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState<string | undefined>();

  useEffect(() => {
    if (touched) {
      const err = validateField(value);
      setError(err);
    }
  }, [value, touched, validateField]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
    setTouched(true);
  };

  const containerClass = `inputText ${error && touched ? "error" : ""}`;
  const labelClass = `inputLabel ${classes}`;
  const inputClass = `form-control inputField ${classes}`;

  return (
    <div className={containerClass}>
      {label && (
        <label htmlFor={name} className={labelClass}>
          {translate(label)}
          {required ? "*" : ""}
        </label>
      )}
      <input
        type={type}
        id={name}
        name={name}
        placeholder={translate(placeholder)}
        value={value}
        onChange={handleChange}
        className={inputClass}
        required={required}
        readOnly={readonly}
        disabled={disabled}
      />
      {error && touched && (
        <label className="errorMessage">{translate(error)}</label>
      )}
    </div>
  );
};

export default InputText;
